import classNames from "classnames";
import { usePoisBountyContext } from "components/PoisBountyWidgetV3/context";
import { useRewards } from "components/PoisBountyWidgetV3/hooks";
import { useAppSelector } from "hooks";
import { selectPoisBountyV3State } from "redux/slices";
import { hideBar } from "./helper";
import { Step } from "./lib";
import { StepConfig } from "./lib/Step/types";
import { ToShopSection } from "./lib/ToShopSection";
import { ProgressStyled } from "./styles";

export interface ProgressStepsProps {}

export const ProgressSteps: React.FC<ProgressStepsProps> = () => {
	const { lp, tracker } = useAppSelector(selectPoisBountyV3State);
	const { isPortrait, isPageVariant } = usePoisBountyContext();
	const { steps } = useRewards(tracker?.rewardClaimStatuses);

	return (
		<>
			{isPortrait && <ToShopSection />}
			<ProgressStyled
				className={classNames([
					isPortrait && "portrait",
					isPageVariant && "page-variant",
					lp >= Number(steps?.slice?.(-1)?.[0]?.target) &&
						isPortrait &&
						"event-completed"
				])}
				stepCount={tracker?.rewardClaimStatuses?.length || 0}
			>
				{steps?.map((reward, index, arr) => {
					const config: StepConfig = {
						hideBar: hideBar(arr, index, lp),
						first: index === 0,
						last: index + 1 === arr.length
					};

					return (
						<Step
							key={index}
							reward={reward}
							stepIndex={index}
							config={config}
						/>
					);
				})}
			</ProgressStyled>
			{!isPortrait && <ToShopSection />}
		</>
	);
};
